import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router'
import { createApplication } from '@/app'

import './styles/index.sass'

const app = createApplication({
  createApp, createRouter, createWebHistory
})
